import React, { useEffect, useRef } from 'react';
import './index.scss';
import { useHistory } from 'react-router-dom';

const SplashAnimation = () => {
  const history = useHistory();
  const soundRef = useRef(null);

  const soundNotification = () => {
    const sound = new Audio(
      'https://mansbucket.s3.eu-west-3.amazonaws.com/nouveau-jingle-netflix.mp3'
    );
    const promise = sound.play();

    if (promise !== undefined) {
      promise.then(() => {}).catch((error) => console.error(error));
    }
  };

  useEffect(() => {
    setTimeout(() => {
      soundNotification();
    }, 100);
  }, [history]);

  return (
    <div>
      <audio
        ref={soundRef}
        src="https://mansbucket.s3.eu-west-3.amazonaws.com/nouveau-jingle-netflix.mp3"
      />
    </div>
  );
};

export default SplashAnimation;
